// Location color mapping for consistent color coding across the application
export const LOCATION_COLORS: Record<string, string> = {
  // Common Dublin area abbreviations
  'Bla': '#3B82F6', // Blue
  'Jun': '#8B5CF6', // Purple
  'Coo': '#0EA5E9', // Sky Blue
  'Dub': '#6366F1', // Indigo
  'Ker': '#8B5CF6', // Purple
  'San': '#14B8A6', // Teal
  'Rah': '#06B6D4', // Cyan
  'Tal': '#A855F7', // Violet
  'Cla': '#EC4899', // Pink
  'Mal': '#0891B2', // Dark Cyan
  'Kin': '#7C3AED', // Deep Purple
  'Lub': '#BE185D', // Rose
  'Bal': '#DB2777', // Deep Pink
  'Don': '#F472B6', // Pink
  'Boo': '#64748B', // Slate
};

/**
 * Get the color for a given location abbreviation
 * @param locationAbbr - The 3-character location abbreviation (e.g., 'Bla', 'Jun')
 * @returns The hex color code for the location, or a default gray if not found
 */
export const getLocationColor = (locationAbbr: string): string => {
  const normalizedAbbr = locationAbbr.charAt(0).toUpperCase() + locationAbbr.slice(1).toLowerCase();
  return LOCATION_COLORS[normalizedAbbr] || '#9CA3AF'; // Default gray if location not found
};

/**
 * Get all available location colors as an array of { abbr, color } objects
 * @returns Array of location color mappings
 */
export const getAllLocationColors = (): Array<{ abbr: string; color: string }> => {
  return Object.entries(LOCATION_COLORS).map(([abbr, color]) => ({ abbr, color }));
}; 